export const getRecipesInCollection = (menuCollections, collectionId) =>
  menuCollections.getIn([collectionId, 'recipesInCollection'], null)
